import { render, staticRenderFns } from "./TheContactList.vue?vue&type=template&id=490b87e3&scoped=true"
import script from "./TheContactList.vue?vue&type=script&lang=js"
export * from "./TheContactList.vue?vue&type=script&lang=js"
import style0 from "./TheContactList.vue?vue&type=style&index=0&id=490b87e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b87e3",
  null
  
)

export default component.exports